<template>
  <div class="bg-white shadow overflow-hidden sm:rounded-md flex flex-col">
    <div class="px-4 sm:px-6 py-4 flex justify-between items-center">
      <div class="text-sm text-gray-600">
        <i18n path="contact_notes.created_by" tag="span">
          <b class="font-medium">{{ user ? user.fullName : $t('global.someone') }}</b>
        </i18n>
      </div>
      <div class="flex items-center space-x-2">
        <NoteListItemActions
          :contact-id="note.notableId"
          :note-id="note.id"
          @destroy="$emit('destroy')"
        />
        <span class="text-sm text-gray-600">{{ dateCreated }}</span>
      </div>
    </div>
    <NoteListItemEdit
      v-if="edit"
      :submit-action="updateNote"
      :content="content"
      @cancel="edit = false"
    />
    <div v-else class="px-4 sm:px-6 py-4 hover:bg-gray-100" v-html="content" @click="edit = true" />
  </div>
</template>

<script>
import moment from 'moment';
import { marked } from 'marked';
import { notesClient } from '@/api/clients';
import NoteListItemActions from './NoteListItemActions.vue';
import NoteListItemEdit from './NoteListItemEdit.vue';

export default {
  components: {
    NoteListItemActions,
    NoteListItemEdit,
  },
  props: {
    note: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      edit: false,
    };
  },
  computed: {
    dateCreated() {
      return moment(this.note.createdAt).format('ddd D MMM Y');
    },
    content() {
      return marked(this.note.content || '');
    },
    user() {
      const { user = null } = this.note;

      if (user === null) {
        return null;
      }

      if (typeof user === 'object') {
        return user;
      }

      return this.$store.state.entities.users.byId[user];
    },
  },
  methods: {
    async updateNote(formData) {
      try {
        await notesClient.update(this.note.id, formData);

        this.$emit('update');

        this.edit = false;

        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
